import React from 'react';
import { SuperAiWorkspaceModal } from '@/features/super-ai/components/SuperAiWorkspaceModal';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  activeRole?: string;
}

export const SuperAiModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  activeRole = 'DEPARTMENT_HEAD',
}) => (
  <SuperAiWorkspaceModal
    isOpen={isOpen}
    onClose={onClose}
    activeRole={activeRole}
  />
);

/** ENTRY CONTRACT: department create button mounts the shared Create Request Hub. */
export { CreateRequestEntry as RequestGatewayModal } from '@/features/request-gateway';
